import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import StorageService from '../services/StorageService';

function Navbar() {
  const auth = StorageService.getAuth();
  const isAuthenticated = auth !== null;
  const isAdmin = auth?.is_admin || false;
  const navigate = useNavigate();

  const handleLogout = () => {
    StorageService.clearAuth();
    navigate('/')
  };

  return (
    <nav className="bg-primary shadow-lg">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to={isAuthenticated ? (isAdmin ? "/newhome" : "/user-home") : "/"} className="flex items-center">
              <img src='https://vaipraconta.com.br/wp-content/uploads/2022/07/LOGO-VAI-PRA-CONTA-1.png' style={{width: '100px'}}/>
            </Link>
          </div>

          <div className="flex space-x-4">
            {isAuthenticated && isAdmin && (
              <Link
                to="/admin/view"
                className="text-white hover:bg-white hover:text-primary px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
              >
                Área Admin
              </Link>
            )}
            {
              isAuthenticated && !isAdmin && (
                  <>
                    <Link
                        to="/user-settings"
                        className="text-white hover:bg-white hover:text-primary px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
                    >
                      Configurações
                    </Link>
                    <Link
                        to="#"
                        className="text-white hover:bg-white hover:text-primary px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
                    >
                      {capitalize(auth.user?.name ?? '')}
                    </Link>
                  </>
                )
            }
            {isAuthenticated ? (
              <button
                onClick={handleLogout}
                className="text-white hover:bg-white hover:text-primary px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
              >
                Logout
              </button>
            ) : (
              <Link
                to="/login"
                className="text-white hover:bg-white hover:text-primary px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

function capitalize(frase) {
  return frase
      .toLowerCase()
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
}